(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallCheckDetailExtController', PhoneCallCheckDetailExtController);

    PhoneCallCheckDetailExtController.$inject = ['entity', '$uibModalInstance'];

    function PhoneCallCheckDetailExtController(entity, $uibModalInstance) {
        var vm = this;

        vm.phoneCallCheck = entity;
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
